import { wgsl } from "../../wgsl-preprocessor/wgsl-preprocessor";

export function getHeatmapDeclChunk() {
  return wgsl /*wgsl*/`
	fn lmap(value: f32, inMin: f32, inMax: f32, outMin: f32, outMax: f32) -> f32 {
		return clamp(outMin + ((outMax - outMin) * (value - inMin)) / (inMax - inMin), outMin, outMax);
	}

	// Gradient with multiple colors in non-equal intervals
	fn colormap(x: f32) -> vec3f {
		var colorsAndStops = ibl.colorsAndStops;
		for (var i = 1; i < NUM_STOPS; i++) {
			if (x <= colorsAndStops[i].stop) {
				var stopPct = lmap(x, colorsAndStops[i - 1].stop, colorsAndStops[i].stop, 0.0, 1.0);
				return mix(colorsAndStops[i - 1].color, colorsAndStops[i].color, stopPct);
			}
		}

		// In case 'x' goes beyond upper bound.
		return colorsAndStops[NUM_STOPS - 1].color;
	}
	`;
};

/**
 * Inverse Distance Weighting (IDW) with p=2, element-wise for numerical stability.
 * slight inefficiency of dual distance square calculation is needed since we can't save intermediary weights.
 * @see wgs/render/chunks/heatmap_frag.glsl
 */
export function getHeatmapChunk() {
  return wgsl /*wgsl*/`

	var sensorCount = materialUniforms.heatmapSensorCountAndOffset & 0x000000ff;
	if (sensorCount > 0) {

		var sensorOffset = materialUniforms.heatmapSensorCountAndOffset >> 8;
		var heatResult: f32 = 0.0;
		var heatWsum: f32 = 0.0;
		var heatFound: bool = false; // at exact location of the sensor
		var heatmapAlpha = ibl.heatmapAlpha;

		for (var i = sensorOffset; i < sensorOffset + sensorCount; i++) {
			var dstVec = in.vWorldPosition.xy - heatmapSensors[i].xy;
			var dstSq = dot(dstVec, dstVec);
			if (dstSq < 1e-6) {
				// deals with discontinuity at 0 distance
				heatResult = heatmapSensors[i][3];
				heatFound = true;
			} else {
				heatWsum += 1 / dstSq;
			}
		}

		if (!heatFound) {
			for (var i = sensorOffset; i < sensorOffset + sensorCount; i++) {
				var dstVec = in.vWorldPosition.xy - heatmapSensors[i].xy;
				var dstSq = dot(dstVec, dstVec);
				heatResult += heatmapSensors[i][3] / (dstSq * heatWsum);
			}
		}

		// Defaults without influence from any sensor
		var sensorColor = vec3f(0.5);
		if (heatResult >= 0.0) {
			heatResult = clamp(heatResult, 0.0, 1.0);
			sensorColor = colormap(heatResult);
		}

		// If this chunk is used in shaders that render ghosted objects, we need to check for that and don't apply the
		// heatmap color, i.e. use 'ghosted ? 0.0 : heatmapAlpha' below.
		output.color = vec4f(mix(vec3f(luminance_post(output.color.rgb)), sensorColor, heatmapAlpha), output.color.a);
		if (heatmapAlpha > 0.0) {
			output.color[3] = max(output.color.a, heatmapAlpha);
		}
	}
	`;
};